import DispatcherEvent from '@carvana/merch-native/DispatcherEvent';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import NativeCapability from '~/constants/common/nativeCapability';
import {
  useIsNativeCapabilityActive,
  useSendMessageToNative
} from '~/context/common/NativeContext';
import { useUserLocation } from '~/context/common/UserContext';

export default function useUpdateGeolocationDispatcher() {
  const shouldUseGeolocationWebView = useIsNativeCapabilityActive(
    NativeCapability.GeolocationWebView
  );
  const sendMessageToNative =
    useSendMessageToNative<DispatcherEvent.UpdateGeolocation>();
  const { city, state, zip } = useUserLocation();

  useSubsequentEffect(() => {
    if (!shouldUseGeolocationWebView) return;

    sendMessageToNative(DispatcherEvent.UpdateGeolocation, {
      city,
      state,
      zip
    });
  }, [city, sendMessageToNative, shouldUseGeolocationWebView, state, zip]);
}
